<template>
  <b-row class="mt-3">
    <b-col>
      <b-card no-body>
        <b-card-header>
          <span class="text-muted text-uppercase"
            >Instrument Identification</span
          >
        </b-card-header>
        <b-card-body>
          <b-form-group label="Name" :label-cols="3" :horizontal="true">
            <b-form-input
              type="text"
              v-model.trim="name"
              placeholder="Instrument Name"
              invalid-feedback="Required"
              :state="!$v.name.$invalid"
            />
          </b-form-group>
          <b-form-group label="Abbreviation" :label-cols="3" :horizontal="true">
            <b-form-input
              type="text"
              v-model.trim="abbrev"
              placeholder="Instrument Abbreviation"
              invalid-feedback="Required"
              :state="!$v.abbrev.$invalid"
            />
          </b-form-group>
          <b-form-group label="Description" :label-cols="3" :horizontal="true">
            <b-form-textarea
              v-model.trim="description"
              placeholder="Instrument Description"
            />
          </b-form-group>
          <b-form-group label="Daily Capacity" :label-cols="3">
            <b-form-input
              type="number"
              v-model.number="daily_capacity"
              placeholder="Daily Capacity"
              invalid-feedback="Required"
              :state="!$v.daily_capacity.$invalid"
            />
          </b-form-group>
          <b-form-group
            label="Per Cycle Capacity"
            :label-cols="3"
            :horizontal="true"
          >
            <b-form-input
              type="number"
              v-model.number="capacity"
              placeholder="Capacity"
              invalid-feedback="Required"
              :state="!$v.capacity.$invalid"
            />
          </b-form-group>
          <b-form-group
            label="Default Runtime"
            :label-cols="3"
            :horizontal="true"
          >
            <b-row class="pr-3">
              <b-col class="pr-0">
                <b-form-input
                  type="number"
                  v-model.number="runtime"
                  placeholder="Runtime"
                  invalid-feedback="Required"
                  :state="!$v.runtime.$invalid"
                />
              </b-col>
              <b-col class="pr-0">
                <b-form-select
                  v-model="runtime_display"
                  :options="runtime_options"
                  invalid-feedback="Required"
                  :state="!$v.runtime_display.$invalid"
                />
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group label="Group Schedule?" :label-cols="3">
            <b-form-checkbox
              v-model="group_schedule"
              :value="1"
              :unchecked-value="0"
            />
          </b-form-group>
          <b-form-group label="Instanceless result?" :label-cols="3">
            <b-form-checkbox
              v-model="instanceless_result"
              :value="1"
              :unchecked-value="0"
            />
          </b-form-group>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate/src";

export default {
  name: "InstrumentIdentificationForm",
  mixins: [validationMixin, ToastNotifications],
  props: {
    form_data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    runtime_options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    abbrev: {
      get() {
        return this.form_data.abbrev;
      },
      set(value) {
        this.updateFormData(value, "abbrev");
      }
    },
    capacity: {
      get() {
        return this.form_data.capacity;
      },
      set(value) {
        this.updateFormData(value, "capacity");
      }
    },
    name: {
      get() {
        return this.form_data.name;
      },
      set(value) {
        this.updateFormData(value, "name");
      }
    },
    description: {
      get() {
        return this.form_data.description;
      },
      set(value) {
        this.updateFormData(value, "description");
      }
    },
    runtime: {
      get() {
        return this.form_data.runtime;
      },
      set(value) {
        this.updateFormData(value, "runtime");
      }
    },
    daily_capacity: {
      get() {
        return this.form_data.daily_capacity;
      },
      set(value) {
        this.updateFormData(value, "daily_capacity");
      }
    },
    runtime_display: {
      get() {
        return this.form_data.runtime_display;
      },
      set(value) {
        this.updateFormData(value, "runtime_display");
      }
    },
    group_schedule: {
      get() {
        return this.form_data.group_schedule;
      },
      set(value) {
        this.updateFormData(value, "group_schedule");
      }
    },
    instanceless_result: {
      get() {
        return this.form_data.instanceless_result;
      },
      set(value) {
        this.updateFormData(value, "instanceless_result");
      }
    }
  },
  validations: {
    abbrev: { required },
    capacity: { required },
    name: { required },
    runtime: { required },
    daily_capacity: { required },
    runtime_display: { required }
  },
  methods: {
    updateFormData(value, field) {
      this.$emit("updateFormData", { value, field });
    }
  }
};
</script>
